import { Button, Flex } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { messages } from '../../AddBeneficiaryPopupContent.messages';
import { useAddBeneficiaryRouting } from './NavigationButtons.hooks';
import { NavigationButtonsProps } from './NavigationButtons.types';

export const NavigationButtons = memo<NavigationButtonsProps>((props) => {
    const {
        activeStep,
        isLoadingFieldsSchema,
        setActiveStep,
        setErrorMessages,
        fieldsSchema,
        fieldsSchemaTransfer,
        setFieldsSchemaTransfer,
    } = props;

    const { goToPrevStep, goToNextStep } = useAddBeneficiaryRouting({
        activeStep,
        setActiveStep,
        setErrorMessages,
        fieldsSchema,
        fieldsSchemaTransfer,
        setFieldsSchemaTransfer,
    });

    return (
        <Flex spacing='16' wrap={false}>
            {activeStep !== 1 && (
                <Button color='blue10' onClick={goToPrevStep} disabled={isLoadingFieldsSchema}>
                    {messages.prevStepButtonText}
                </Button>
            )}

            {activeStep !== 4 && (
                <Button color='blue80' type='button' onClick={goToNextStep} disabled={isLoadingFieldsSchema}>
                    {messages.nextStepButtonText}
                </Button>
            )}

            {activeStep === 4 && (
                <Button color='blue80' type='submit'>
                    {messages.createButtonText}
                </Button>
            )}
        </Flex>
    );
});

NavigationButtons.displayName = 'NavigationButtons';
